// import React from "react";
import * as React from "react";

import { FaCheck, FaGift } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { TiTick } from "react-icons/ti";

function GoldPackage() {
  const [showMore, setShowMore] = React.useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  return (
    <div>
      <div className="flex justify-between   ">
        {/* Silver */}

        {/* Gold */}
        <div className="flex flex-col  space-y-5 py-10 px-16 bg-primary rounded-lg shadow-md">
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-4 rounded-lg">
              <FaGift className="text-3xl text-primary " />
            </div>
            <p className="text-2xl font-semibold text-white">Gold</p>
          </div>
          <div className="flex flex-col  gap-3">
            <div className="flex gap-3 items-center">
              <div>
                <h1 className="text-6xl font-semibold text-white">$99</h1>
              </div>
              <p className="text-white">/monthly</p>
            </div>
            <h2 className="text-2xl font-bold text-white">What's Included</h2>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className=" text-lg text-white"> Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-white  text-lg"> Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-white text-lg"> Images Per Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-red-500 rounded-full bg-white text-lg font-semibold">
                <IoCloseSharp />
              </div>
              <p className="text-white text-lg"> Enquiry Form</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-red-500 rounded-full bg-white text-lg font-semibold">
                <IoCloseSharp />
              </div>
              <p className="text-white  text-lg"> Video</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-white  text-lg"> Amenities Per Listing (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-white  text-lg"> Features Per Listing (3)</p>
            </div>
            {showMore ? (
              <div className="space-y-3">
                <div className="flex gap-4 items-center ">
                  <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                    <FaCheck />
                  </div>
                  <p className="text-white  text-lg">
                    {" "}
                    Social Links Per Listing (3)
                  </p>
                </div>
                <div className="flex gap-4 items-center ">
                  <div className="flex items-center justify-center w-6 h-6 text-green-500 rounded-full bg-white text-xs font-semibold">
                    <FaCheck />
                  </div>
                  <p className="text-white  text-lg"> FAQs Per Listing (3)</p>
                </div>
              </div>
            ) : (
              " "
            )}
            <div>
              <button
                onClick={handleShowMore}
                className="text-white font-semibold"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
            <div>
              <button
                // onClick={handleDropdownCustomer}
                className="bg-white text-primary text-lg mt-6 font-semibold px-8 py-3 border border-[#F8735F]  rounded-lg"
              >
                Purchase
              </button>
            </div>
          </div>
        </div>
        {/* Platinum */}
      </div>
    </div>
  );
}

export default GoldPackage;
